import Oboe from 'oboe/dist/oboe-browser';

import { getBootstrap } from '@client/app/bootstrap';

import { APITransport } from '@client/transports/api';

const { API } = getBootstrap();

export const SyncService = {
  streamSync(endpoint, scope, body, pattern = '{email}') {
    const { token } = getBootstrap();

    return Oboe({
      method: 'POST',
      url: `${API}/rest/domain/execute/stream${endpoint}${scope}`,
      body,
      headers: {
        Authorization: `Bearer ${token}`
      },
      pattern,
      useXDomain: true,
      withCredentials: true
    });
  },
  sync(endpoint, scope, body = {}) {
    return APITransport.post({
      path: `rest/domain/execute/stream${endpoint}${scope}`,
      body
    });
  },
  checkConnection(type) {
    return APITransport.post({
      path: `rest/domain/execute/${type}`,
      // This is a probe: checkConnections() calls it for every type in SYNC_CONNECTIONS
      // and reads `status >= 400` as "not connected", so a 500 here is the expected
      // answer for a domain that doesn't use the integration, not a fault.
      captureErrors: false
    });
  },
  getSyncHistory() {
    return APITransport.post({
      path: `/rest/domain/execute/getsynchistory`
    });
  }
};
